/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 20/12/21
 */
import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
// import SelectElementCmp from '@/utils/SelectElementCmp';
// import UsersApiService from '@/modules/users/services/UsersApiService';
import {OperatorFilter, TermFilter} from '@dofleini/query-builder';
import {useGetOne} from '@/modules/users/hooks/useUsers';
import EmployeesApiService from '@/modules/employees/services/EmployeesApiService';
import {useClientFilter} from '@/hooks/useClientFilter';
import AsyncSelect from '@/components/AsyncSelect';
// import {useQueryClient} from 'react-query';

const AuditorAuditsSelectAuditor = ({value, onChange, isViewMode, ...props}) => {
  const {data} = useGetOne(isViewMode ? value: null);
  const { currentClient } = useClientFilter();
  // const queryClient = useQueryClient();

  // useEffect(() => {
  //   queryClient.invalidateQueries('audit-auditor');
  // }, [currentClient?._id, queryClient]);

  const filters = useMemo(() => {
    let defaultFilter = new OperatorFilter({
      type: 'AND', filters: [
        new TermFilter({field: 'isRoot', value: true}),
        new TermFilter({field: 'verified', value: true}),
      ]
    });
    if (currentClient) {
      defaultFilter.filters.push(new TermFilter({field: 'client', value: currentClient._id}));
    }
    return defaultFilter.toQuery();
  }, [currentClient]);

  if (isViewMode) {
    return (
      <>
        {data?.name || 'N/A'}
      </>
    );
  }

  return (
    <AsyncSelect
      queryKey={'audit-auditor'}
      filters={filters}
      service={EmployeesApiService}
      customMethod="/ms-core/api/workers/search-users"
      value={value}
      deferFetchUntilOpen={true}
      onChange={onChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      nameToShow="fullName"
      additionalParams={{client: currentClient?._id}}
      {...props}
    />
  );
};

AuditorAuditsSelectAuditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  isViewMode: PropTypes.func,
};

export default memo(AuditorAuditsSelectAuditor);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {object} entity this is entity type
 * */
export const renderService = (text, entity) => {
  return (
    <AuditorAuditsSelectAuditor value={text} entity={entity} isViewMode={true}/>
  );
};

